<style scoped>
/* ===== CODEMIRROR ===== */
.codemirror { font-size: 11px; }
.codemirror .CodeMirror { height: 350px; border-radius: 6px; }

/* ===== FORM BODY ===== */
.form-body { padding: 16px 20px; }

/* ===== FORM SECTIONS ===== */
.form-section { margin-bottom: 16px; }
.form-section:last-child { margin-bottom: 0; }

.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

/* ===== COMPACT FORM GROUP ===== */
.form-body .form-group { margin-bottom: 10px; }

.form-body .form-group > label {
  font-size: 12px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 3px;
}

/* ===== TOGGLE ROW ===== */
.toggle-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #344054;
  transition: all 0.15s;
  user-select: none;
}

.toggle-item:hover { background: #f9fafb; }

.toggle-item.active {
  border-color: #3a3e81;
  background: #f2f2f8;
  color: #3a3e81;
}

.toggle-item input[type="checkbox"] {
  accent-color: #3a3e81;
  pointer-events: none;
}

/* ===== ICONE GRID ===== */
.icone-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.icone-option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 2px solid #e4e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #667085;
  transition: all 0.15s;
}

.icone-option:hover { border-color: #b0bec5; }

.icone-option.active {
  border-color: #3a3e81;
  background: #f2f2f8;
  color: #3a3e81;
}

.icone-option input[type="radio"] { display: none; }

/* ===== SISTEMA GRID ===== */
.sistema-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sistema-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #344054;
  transition: all 0.15s;
}

.sistema-option:hover { background: #f9fafb; }

/* ===== TIPO REGRA SELECTOR ===== */
.tipo-regra-selector {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.tipo-regra-option {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px 16px;
  border: 2px solid #e4e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
  user-select: none;
}

.tipo-regra-option:hover {
  border-color: #b0bec5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

.tipo-regra-option.active {
  border-color: #3a3e81;
  background: #f2f2f8;
  box-shadow: 0 2px 12px rgba(58, 62, 129, 0.15);
}

.tipo-regra-option.active .tipo-regra-icon { color: #3a3e81; }
.tipo-regra-option.active .tipo-regra-label { color: #3a3e81; }

.tipo-regra-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f3f5;
  color: #6c757d;
  font-size: 18px;
  margin-bottom: 10px;
  transition: all 0.2s ease;
}

.tipo-regra-option.active .tipo-regra-icon { background: #e3e3ee; }

.tipo-regra-label {
  font-weight: 600;
  font-size: 13px;
  color: #344054;
  margin-bottom: 2px;
}

.tipo-regra-desc {
  font-size: 11px;
  color: #98a2b3;
  text-align: center;
  line-height: 1.3;
}

.tipo-regra-check {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #3a3e81;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

/* ===== REGRA CONTENT AREA ===== */
.regra-content {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  min-height: 120px;
}

/* ===== REGRA FIXA LIST ===== */
.regra-fixa-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.regra-fixa-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
}

.regra-fixa-item:hover {
  border-color: #b0bec5;
  background: #fafbfc;
}

.regra-fixa-item.active {
  border-color: #3a3e81;
  background: #eceaf3;
}

.rfi-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f1f3f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  font-size: 16px;
  flex-shrink: 0;
  transition: all 0.15s;
}

.regra-fixa-item.active .rfi-icon {
  background: #e3e3ee;
  color: #3a3e81;
}

.rfi-name {
  font-weight: 600;
  font-size: 14px;
  color: #1d2939;
}

.rfi-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
  line-height: 1.4;
}

/* ===== PROMO ALERT ===== */
.promo-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #eff8ff;
  border: 1px solid #b2ddff;
  border-radius: 8px;
  margin-top: 12px;
  font-size: 13px;
  color: #1849a9;
}

.promo-info .promo-icon {
  color: #2e90fa;
  font-size: 16px;
  flex-shrink: 0;
}

/* ===== MANUAL PRODUCTS ===== */
.manual-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.manual-header .search-wrapper {
  position: relative;
  flex: 0 0 280px;
}

.manual-header .search-wrapper .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  font-size: 14px;
}

.manual-header .search-wrapper .form-control {
  padding-left: 36px;
  border-radius: 8px;
}

.selected-counter {
  font-size: 13px;
  color: #667085;
  font-weight: 500;
  white-space: nowrap;
}

.selected-counter strong {
  color: #3a3e81;
}

.loading-indicator {
  text-align: center;
  padding: 20px;
  color: #98a2b3;
  font-size: 13px;
}

/* Product list table */
.produto-list {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  max-height: 400px;
  overflow-y: auto;
}

.produto-list-header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e9ecef;
  font-size: 12px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.pl-check { flex: 0 0 40px; }
.pl-img { flex: 0 0 80px; }
.pl-info { flex: 1; }

.produto-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f2f4f7;
  cursor: pointer;
  transition: background 0.1s;
}

.produto-row:last-child { border-bottom: none; }
.produto-row:hover { background: #f9fafb; }

.produto-row.selected {
  background: #f2f2f8;
}

.produto-row .pl-check input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3a3e81;
}

.pl-thumb {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.pl-thumb img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.pl-thumb .thumb-placeholder {
  color: #d0d5dd;
  font-size: 22px;
}

.pl-name {
  font-weight: 600;
  font-size: 13px;
  color: #1d2939;
  line-height: 1.3;
  margin-bottom: 2px;
}

.pl-id {
  font-size: 12px;
  color: #98a2b3;
}

.manual-empty {
  text-align: center;
  padding: 40px 20px;
  color: #98a2b3;
}

.manual-empty .empty-icon {
  font-size: 36px;
  color: #d0d5dd;
  margin-bottom: 10px;
}

.manual-empty p {
  font-size: 13px;
  margin: 0;
}

/* ===== SQL BANCO ===== */
.banco-select-row { display: flex; gap: 12px; margin-bottom: 12px; }

.banco-option {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 2px solid #e4e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 13px;
  font-weight: 500;
  color: #667085;
}

.banco-option:hover { border-color: #b0bec5; }

.banco-option.active {
  border-color: #3a3e81;
  background: #f2f2f8;
  color: #3a3e81;
}

.banco-option .banco-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #d0d5dd;
  position: relative;
  flex-shrink: 0;
}

.banco-option.active .banco-radio { border-color: #3a3e81; }

.banco-option.active .banco-radio::after {
  content: "";
  width: 8px;
  height: 8px;
  background: #3a3e81;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
}

/* ===== MODAL FOOTER (fora do modalbox) ===== */
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}

/* ===== VITRINE MOCKUP PREVIEW ===== */
.mockup-side-by-side {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.mockup-panel {
  border: 1px solid #e0e3e8;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.mockup-panel-desktop { flex: 0 0 80%; max-width: 80%; }
.mockup-panel-mobile { flex: 1; min-width: 0; }

.mockup-panel-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 0;
  font-size: 11px;
  font-weight: 600;
  color: #98a2b3;
  background: #f4f5f7;
  border-bottom: 1px solid #e0e3e8;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* --- Mockup Desktop: side panel + cards --- */
.mockup-desktop {
  display: flex;
  padding: 16px;
  gap: 10px;
  background: #f9fafb;
  min-height: 260px;
}

.mk-side-panel {
  flex: 0 0 140px;
  border-radius: 6px;
  color: #fff;
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 230px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.mk-side-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.mk-side-desc {
  font-size: 11px;
  line-height: 1.3;
  margin-top: 6px;
  opacity: 0.9;
}

.mk-side-btn {
  display: inline-block;
  border: 1px solid rgba(255,255,255,.7);
  border-radius: 4px;
  padding: 5px 0;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  margin-top: auto;
}

.mk-cards-area {
  flex: 1;
  display: flex;
  gap: 10px;
  overflow: hidden;
  position: relative;
  align-items: stretch;
}

/* Setas do carrossel */
.mk-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0,0,0,.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  font-size: 10px;
  z-index: 2;
}

.mk-arrow-left { left: 2px; }
.mk-arrow-right { right: 2px; }

/* Card de produto no mockup */
.mk-card {
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
}

/* Icone da vitrine no card (topo direito) */
.mk-card-vitrine-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 14px;
  z-index: 2;
  opacity: 0.85;
}

/* Flag ribbon (tag destaque) */
.mk-flag {
  position: absolute;
  left: -5px;
  top: -5px;
  width: 62px;
  height: 62px;
  overflow: hidden;
  z-index: 1;
}

.mk-flag-content {
  display: block;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  transform: rotate(-45deg);
  line-height: 16px;
  width: 85px;
  position: absolute;
  top: 15px;
  left: -18px;
}

.mk-card-img {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #f9fafb;
  color: #c0c7d0;
  font-size: 30px;
}

.mk-card-code {
  padding: 0 10px;
  position: relative;
}

.mk-card-code::before {
  content: "";
  width: 100%;
  position: absolute;
  top: 7px;
  left: 0;
  border-bottom: 1px solid #e4e7eb;
}

.mk-card-code span {
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 50px;
  padding: 0 5px 1px;
  background: #fff;
  font-size: 9px;
  font-weight: 700;
  color: #555;
  margin-left: 6px;
}

.mk-card-body {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
}

.mk-skel {
  height: 7px;
  background: #e2e8f0;
  border-radius: 4px;
  margin-bottom: 4px;
}

.mk-skel.sm { height: 5px; background: #edf0f4; }

.mk-card-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  padding: 4px 0;
  font-size: 9px;
  font-weight: 600;
  color: #888;
  margin-top: 8px;
}

/* --- Mockup Mobile: top banner + cards --- */
.mockup-mobile {
  padding: 10px;
  background: #f9fafb;
  flex: 1;
}

.mk-top-banner {
  border-radius: 6px;
  color: #fff;
  min-height: 40px;
  padding: 8px 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 8px;
  background-size: cover;
  background-position: center;
}

.mk-top-banner h5 {
  font-size: 11px;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mk-top-btn-small {
  border: 1px solid rgba(255,255,255,.7);
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 8px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}

.mk-mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.mk-mobile-cards .mk-card {
  flex: none;
}

/* Panel vazio caso nada configurado */
.mk-empty-side {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  opacity: 0.5;
  font-size: 11px;
  text-align: center;
}
</style>

<template>
  <modal
    name="vitrineEdit"
    height="auto"
    width="1000"
    :lazy="true"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">

          <!-- ==================== ABA 1: CONFIGURACOES GERAIS ==================== -->
          <CTab title="Configurações Gerais">
            <div class="form-body">

              <!-- Informacoes Basicas -->
              <div class="form-section">
                <div class="section-label">INFORMAÇÕES BÁSICAS</div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Título</label>
                      <input class="form-control" v-model="item.titulo" maxlength="25" />
                      <div class="message">{{ validation.firstError("item.titulo") }}</div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Ordem</label>
                      <input class="form-control" v-model="item.ordem" type="number" />
                      <div class="message">{{ validation.firstError("item.ordem") }}</div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Cor</label>
                      <ColorInput v-model="item.cor" />
                      <div class="message">{{ validation.firstError("item.cor") }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Descrição</label>
                      <input class="form-control" v-model="item.descricao" maxlength="150" />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Tag no Produto</label>
                      <input class="form-control" v-model="item.tag_produto" maxlength="30" />
                      <div class="message">{{ validation.firstError("item.tag_produto") }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Opcoes e Toggles -->
              <div class="form-section">
                <div class="section-label">OPÇÕES</div>
                <div class="toggle-row">
                  <label class="toggle-item" :class="{ active: item.ativo }">
                    <input type="checkbox" v-model="item.ativo" /> Ativo
                  </label>
                  <label class="toggle-item" :class="{ active: item.home }">
                    <input type="checkbox" v-model="item.home" /> Exibir na Home
                  </label>
                  <label class="toggle-item" :class="{ active: item.exibe_titulo }">
                    <input type="checkbox" v-model="item.exibe_titulo" /> Exibe Título
                  </label>
                  <label class="toggle-item" :class="{ active: item.exibe_descricao }">
                    <input type="checkbox" v-model="item.exibe_descricao" /> Exibe Descrição
                  </label>
                  <label class="toggle-item" :class="{ active: item.destacar_produto }">
                    <input type="checkbox" v-model="item.destacar_produto" /> Destacar Produto
                  </label>
                </div>
              </div>

              <!-- Icone -->
              <div class="form-section">
                <div class="section-label">ÍCONE</div>
                <div class="icone-grid">
                  <label
                    class="icone-option"
                    v-for="icone in iconesDisponiveis"
                    :key="icone.descricao"
                    :class="{ active: item.icone === icone.descricao }"
                  >
                    <input type="radio" v-model="item.icone" :value="icone.descricao" />
                    <fa-icon :icon="icone.descricao" />
                  </label>
                </div>
                <div class="section-label" style="margin-top: 14px">SISTEMA DE EXIBIÇÃO</div>
                <div class="sistema-grid">
                  <label class="sistema-option" v-for="sistema in sistemasDisponiveis" :key="sistema.id">
                    <input type="checkbox" v-model="item.sistemas" :value="sistema.id" />
                    <span>{{ sistema.descricao }}</span>
                  </label>
                </div>
              </div>

              <!-- Imagens -->
              <div class="form-section">
                <div class="section-label">IMAGENS DE CAPA</div>
                <div class="row">
                  <div class="col-md-6">
                    <image-picker
                      label="Imagem desktop (165 x 330 px)"
                      placeholder="Colar URL ou clique ao lado para upload"
                      v-model="item.imagem_desktop"
                    />
                  </div>
                  <div class="col-md-6">
                    <image-picker
                      label="Imagem mobile (527 x 60 px)"
                      placeholder="Colar URL ou clique ao lado para upload"
                      v-model="item.imagem_mobile"
                    />
                  </div>
                </div>
              </div>

              <!-- MOCKUP PREVIEW -->
              <div class="form-section">
                <div class="section-label">PREVIEW DA VITRINE</div>
                <div class="mockup-side-by-side">

                  <!-- DESKTOP (80%) -->
                  <div class="mockup-panel mockup-panel-desktop">
                    <div class="mockup-panel-label">
                      <fa-icon icon="desktop" /> Desktop
                    </div>
                    <div class="mockup-desktop">
                      <div class="mk-side-panel" :style="sidePanelStyle">
                        <div>
                          <div class="mk-side-title" v-if="item.exibe_titulo">
                            {{ item.titulo || 'Título' }}
                          </div>
                          <div class="mk-side-desc" v-if="item.exibe_descricao && item.descricao">
                            {{ item.descricao }}
                          </div>
                        </div>
                        <div class="mk-side-btn">VER MAIS</div>
                      </div>
                      <div class="mk-cards-area">
                        <div class="mk-arrow mk-arrow-left"><fa-icon icon="chevron-left" /></div>
                        <div class="mk-card" v-for="n in 4" :key="'dk-' + n">
                          <div class="mk-flag" v-if="item.destacar_produto && item.tag_produto">
                            <div class="mk-flag-content" :style="{ background: item.cor || '#999' }">{{ item.tag_produto }}</div>
                          </div>
                          <div class="mk-card-vitrine-icon" v-if="item.icone" :style="{ color: item.cor || '#999' }">
                            <fa-icon :icon="item.icone" />
                          </div>
                          <div class="mk-card-img"><fa-icon icon="image" /></div>
                          <div class="mk-card-code"><span>{{ 10000 + n * 1234 }}</span></div>
                          <div class="mk-card-body">
                            <div>
                              <div class="mk-skel" :style="{ width: (55 + n * 8) + '%' }"></div>
                              <div class="mk-skel sm" :style="{ width: (40 + n * 5) + '%' }"></div>
                            </div>
                            <div class="mk-card-btn">
                              <fa-icon icon="shopping-cart" style="font-size: 8px" /> Vender agora
                            </div>
                          </div>
                        </div>
                        <div class="mk-arrow mk-arrow-right"><fa-icon icon="chevron-right" /></div>
                      </div>
                    </div>
                  </div>

                  <!-- MOBILE (20%) -->
                  <div class="mockup-panel mockup-panel-mobile">
                    <div class="mockup-panel-label">
                      <fa-icon icon="mobile-alt" /> Mobile
                    </div>
                    <div class="mockup-mobile">
                      <div class="mk-top-banner" :style="topBannerStyle">
                        <h5 v-if="item.exibe_titulo">{{ item.titulo || 'Título' }}</h5>
                        <span v-else></span>
                        <span class="mk-top-btn-small">VER MAIS</span>
                      </div>
                      <div class="mk-mobile-cards">
                        <div class="mk-card" :key="'mb-1'">
                          <div class="mk-flag" v-if="item.destacar_produto && item.tag_produto">
                            <div class="mk-flag-content" :style="{ background: item.cor || '#999' }">{{ item.tag_produto }}</div>
                          </div>
                          <div class="mk-card-vitrine-icon" v-if="item.icone" :style="{ color: item.cor || '#999' }">
                            <fa-icon :icon="item.icone" />
                          </div>
                          <div class="mk-card-img"><fa-icon icon="image" /></div>
                          <div class="mk-card-code"><span>11234</span></div>
                          <div class="mk-card-body">
                            <div>
                              <div class="mk-skel" style="width: 63%"></div>
                              <div class="mk-skel sm" style="width: 45%"></div>
                            </div>
                            <div class="mk-card-btn">
                              <fa-icon icon="shopping-cart" style="font-size: 8px" /> Vender agora
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </CTab>

          <!-- ==================== ABA 2: REGRA DE PRODUTOS ==================== -->
          <CTab title="Regra de Produtos">
            <div class="form-body">

              <!-- Seletor de tipo -->
              <div class="section-label">SELECIONE A REGRA</div>
              <div class="tipo-regra-selector">
                <div
                  class="tipo-regra-option"
                  :class="{ active: item.tipo_regra === 'fixa' }"
                  @click="onTipoRegraChange('fixa')"
                >
                  <div class="tipo-regra-check" v-if="item.tipo_regra === 'fixa'">
                    <fa-icon icon="check" />
                  </div>
                  <div class="tipo-regra-icon"><fa-icon icon="sliders-h" /></div>
                  <div class="tipo-regra-label">Regra Fixa</div>
                  <div class="tipo-regra-desc">Campos do ERP</div>

                </div>
                <div
                  class="tipo-regra-option"
                  :class="{ active: item.tipo_regra === 'manual' }"
                  @click="onTipoRegraChange('manual')"
                >
                  <div class="tipo-regra-check" v-if="item.tipo_regra === 'manual'">
                    <fa-icon icon="check" />
                  </div>
                  <div class="tipo-regra-icon"><fa-icon icon="hand-pointer" /></div>
                  <div class="tipo-regra-label">Manual</div>
                  <div class="tipo-regra-desc">Seleção de produtos</div>
                </div>
                <div
                  class="tipo-regra-option"
                  :class="{ active: item.tipo_regra === 'tag_filtro' }"
                  @click="onTipoRegraChange('tag_filtro')"
                >
                  <div class="tipo-regra-check" v-if="item.tipo_regra === 'tag_filtro'">
                    <fa-icon icon="check" />
                  </div>
                  <div class="tipo-regra-icon"><fa-icon icon="filter" /></div>
                  <div class="tipo-regra-label">Tag Filtro</div>
                  <div class="tipo-regra-desc">Filtro dinâmico</div>
                </div>
                <div
                  class="tipo-regra-option"
                  :class="{ active: item.tipo_regra === 'sql' }"
                  @click="onTipoRegraChange('sql')"
                >
                  <div class="tipo-regra-check" v-if="item.tipo_regra === 'sql'">
                    <fa-icon icon="check" />
                  </div>
                  <div class="tipo-regra-icon"><fa-icon icon="code" /></div>
                  <div class="tipo-regra-label">Avançado</div>
                  <div class="tipo-regra-desc">Query SQL</div>
                </div>
              </div>

              <!-- ===== REGRA FIXA ===== -->
              <div class="regra-content" v-if="item.tipo_regra === 'fixa'">
                <div class="section-label" style="margin-bottom: 10px">SELECIONE UM TIPO</div>
                <div class="regra-fixa-list">
                  <div
                    v-for="regra in regrasFixasEnriched"
                    :key="regra.value"
                    class="regra-fixa-item"
                    :class="{ active: item.coluna === regra.value }"
                    @click="item.coluna = regra.value"
                  >
                    <div class="rfi-icon">
                      <fa-icon :icon="regra.icon" />
                    </div>
                    <div class="rfi-info">
                      <div class="rfi-name">{{ regra.label }}</div>
                      <div class="rfi-desc">{{ regra.desc }}</div>
                    </div>
                  </div>
                </div>
                <div class="promo-info" v-if="item.coluna === 'promocao'">
                  <fa-icon icon="info-circle" class="promo-icon" />
                  <span>
                    A vitrine de Promoção é dinâmica: os produtos são calculados em tempo real
                    com base nas promoções ativas e não são pré-computados.
                  </span>
                </div>
              </div>

              <!-- ===== SELECAO MANUAL ===== -->
              <div class="regra-content" v-if="item.tipo_regra === 'manual'">
                <div class="manual-header">
                  <div class="search-wrapper">
                    <fa-icon icon="search" class="search-icon" />
                    <input
                      class="form-control"
                      v-model="searchTerm"
                      placeholder="Buscar"
                      @input="debounceSearch"
                    />
                  </div>
                  <span class="selected-counter">
                    <strong>{{ produtosSelecionados.length }}</strong> selecionados
                  </span>
                </div>

                <div v-if="searchLoading" class="loading-indicator">
                  <fa-icon icon="spinner" spin /> Buscando...
                </div>

                <div v-if="displayedProducts.length > 0" class="produto-list">
                  <div class="produto-list-header">
                    <div class="pl-check"></div>
                    <div class="pl-img">Imagem</div>
                    <div class="pl-info">Produto</div>
                  </div>
                  <div
                    v-for="produto in displayedProducts"
                    :key="'pl-' + produto.id"
                    class="produto-row"
                    :class="{ selected: isProdutoSelecionado(produto.id) }"
                    @click="toggleProduto(produto)"
                  >
                    <div class="pl-check">
                      <input
                        type="checkbox"
                        :checked="isProdutoSelecionado(produto.id)"
                        @click.stop="toggleProduto(produto)"
                      />
                    </div>
                    <div class="pl-img">
                      <div class="pl-thumb">
                        <img
                          v-if="produto.imagemId"
                          :src="getImageUrl(produto)"
                          :alt="produto.descComp || produto.descNF"
                        />
                        <fa-icon v-else icon="cubes" class="thumb-placeholder" />
                      </div>
                    </div>
                    <div class="pl-info">
                      <div class="pl-name">{{ produto.descComp || produto.descNF || produto.descricao }}</div>
                      <div class="pl-id">ID: {{ produto.id }}</div>
                    </div>
                  </div>
                </div>

                <div v-else-if="!searchLoading" class="manual-empty">
                  <div class="empty-icon"><fa-icon icon="inbox" /></div>
                  <p v-if="searchTerm && searchTerm.length >= 2">Nenhum produto encontrado</p>
                  <p v-else-if="produtosSelecionados.length === 0">Busque produtos para selecionar</p>
                  <p v-else>Nenhum produto na busca. {{ produtosSelecionados.length }} selecionado(s).</p>
                </div>
              </div>

              <!-- ===== TAG FILTRO ===== -->
              <div class="regra-content" v-if="item.tipo_regra === 'tag_filtro'">
                <div class="section-label" style="margin-bottom: 10px">SELECIONE AS TAGS DE PRODUTO</div>
                <TabelaSelecaoTagFiltro
                  entidade="produto"
                  v-model="item.tagsFiltro"
                />
              </div>

              <!-- ===== SQL AVANCADO ===== -->
              <div class="regra-content" v-if="item.tipo_regra === 'sql'">
                <div class="section-label" style="margin-bottom: 10px">SQL CUSTOMIZADO</div>
                <div style="margin-bottom: 14px">
                  <label style="font-size: 12px; font-weight: 500; color: #667085; margin-bottom: 6px">
                    Banco de Dados
                  </label>
                  <div class="banco-select-row">
                    <div class="banco-option" :class="{ active: item.banco === 'LOCAL' }" @click="item.banco = 'LOCAL'">
                      <div class="banco-radio"></div>
                      <fa-icon icon="database" /> LOCAL
                    </div>
                    <div class="banco-option" :class="{ active: item.banco === 'ERP' }" @click="item.banco = 'ERP'">
                      <div class="banco-radio"></div>
                      <fa-icon icon="building" /> ERP
                    </div>
                  </div>
                </div>
                <div class="codemirror">
                  <codemirror id="code" v-model="item.sql" :options="code_options" />
                </div>
              </div>

            </div>
          </CTab>
        </CTabs>
      </div>
    </div>

    <!-- Footer FORA do modalbox -->
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" :disabled="validation.hasError()" @click="handleSubmit()">
        Salvar
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import ColorInput from "../../components/ColorInput";
import ImagePicker from "../../components/ImagePicker";
import CloseModal from "../../components/CloseModal";
import TabelaSelecaoTagFiltro from "../../components/TagFiltro/TabelaSelecaoTagFiltro";
import { codemirror } from "vue-codemirror";
import { get } from "@/helpers/apiRequest";
import { cdnUrlProduto } from "@/helpers/url";

const Validator = SimpleVueValidation.Validator.create({
  templates: { required: "Campo de preenchimento obrigatório" },
});

let searchTimeout = null;

const regraFixaDetails = {
  promocao: {
    icon: "dollar-sign",
    desc: "Exibe produtos com promoção ativa. Vitrine dinâmica calculada em tempo real.",
  },
  lancamento: {
    icon: "star",
    desc: "Campo LANÇAMENTO da view de estoque. Confirme se está mapeado na integração.",
  },
  outlet: {
    icon: "tag",
    desc: "Campo OUTLET da view de estoque. Confirme se está mapeado na integração.",
  },
  destaque: {
    icon: "trophy",
    desc: "Exibe produtos marcados como destaque, promovendo itens estratégicos e lançamentos.",
  },
  destaque2: {
    icon: "medal",
    desc: "Campo DESTAQUE2 da view de estoque. Confirme se está mapeado na integração.",
  },
  destaque3: {
    icon: "award",
    desc: "Campo DESTAQUE3 da view de estoque. Confirme se está mapeado na integração.",
  },
  destaque4: {
    icon: "thumbs-up",
    desc: "Campo DESTAQUE4 da view de estoque. Confirme se está mapeado na integração.",
  },
  destaque5: {
    icon: "check-circle",
    desc: "Campo DESTAQUE5 da view de estoque. Confirme se está mapeado na integração.",
  },
};

export default {
  name: "vitrinesEdit",
  components: { ColorInput, ImagePicker, CloseModal, codemirror, TabelaSelecaoTagFiltro },
  props: ["onClose", "onSubmit", "item", "close", "sistemasDisponiveis", "iconesDisponiveis"],
  data() {
    return {
      regrasFixas: [],
      searchTerm: "",
      searchResults: [],
      searchLoading: false,
      produtosSelecionados: [],
    };
  },

  validators: {
    "item.titulo": (value) => Validator.value(value).required(),
    "item.cor": (value) => Validator.value(value).required(),
    "item.tag_produto": (value) => Validator.value(value).required(),
    "item.ordem": (value) => Validator.value(value).required(),
  },

  computed: {
    code_options() {
      return {
        tabSize: 4,
        styleActiveLine: false,
        lineNumbers: true,
        line: true,
        mode: "text/x-sql",
        autoRefresh: true,
        lineWrapping: true,
        readOnly: false,
        disabled: true,
        theme: "monokai",
        showCursorWhenSelecting: false,
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
      };
    },
    regrasFixasEnriched() {
      return this.regrasFixas.map((regra) => ({
        ...regra,
        icon: regraFixaDetails[regra.value]?.icon || "circle",
        desc: regraFixaDetails[regra.value]?.desc || "Regra de estoque do ERP.",
      }));
    },
    displayedProducts() {
      if (this.searchTerm && this.searchTerm.length >= 2 && this.searchResults.length > 0) {
        return this.searchResults;
      }
      return this.produtosSelecionados;
    },
    sidePanelStyle() {
      const s = {};
      s.backgroundColor = this.item.cor || "#555";
      if (this.item.imagem_desktop) {
        s.backgroundImage = `url('${this.item.imagem_desktop}')`;
      }
      return s;
    },
    topBannerStyle() {
      const s = {};
      s.backgroundColor = this.item.cor || "#555";
      if (this.item.imagem_mobile) {
        s.backgroundImage = `url('${this.item.imagem_mobile}')`;
      }
      return s;
    },
  },

  watch: {
    "item.id": {
      handler(newVal) {
        if (newVal && this.item.tipo_regra === "manual") {
          this.loadProdutosManuais();
        }
        this.searchTerm = "";
        this.searchResults = [];
      },
    },
  },

  methods: {
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          if (this.item.tipo_regra === "manual") {
            this.item.produtos = this.produtosSelecionados.map((p) => p.id);
          }
          if (this.item.banco) {
            this.item.banco = this.item.banco.toUpperCase();
          }
          this.onSubmit(this.item);
        }
      });
    },
    onTipoRegraChange(tipo) {
      this.item.tipo_regra = tipo;
      if (tipo !== "fixa") this.item.coluna = "";
      if (tipo !== "tag_filtro") this.item.tagsFiltro = [];
      if (tipo !== "sql") {
        this.item.sql = "";
        this.item.banco = "LOCAL";
      }
      if (tipo !== "manual") {
        this.produtosSelecionados = [];
        this.searchResults = [];
        this.searchTerm = "";
      }
    },

    debounceSearch() {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => { this.searchProdutos(); }, 300);
    },
    searchProdutos() {
      if (!this.searchTerm || this.searchTerm.length < 2) {
        this.searchResults = [];
        return;
      }
      this.searchLoading = true;
      get(`/admin/marketing/vitrines/search-produtos?termo=${encodeURIComponent(this.searchTerm)}&take=20`)
        .then((json) => {
          this.searchResults = json;
          this.searchLoading = false;
        })
        .catch(() => {
          this.searchResults = [];
          this.searchLoading = false;
        });
    },

    toggleProduto(produto) {
      if (this.isProdutoSelecionado(produto.id)) {
        this.removeProduto(produto.id);
      } else {
        this.addProduto(produto);
      }
    },
    addProduto(produto) {
      if (!this.isProdutoSelecionado(produto.id)) {
        this.produtosSelecionados.push(produto);
      }
    },
    removeProduto(produtoId) {
      this.produtosSelecionados = this.produtosSelecionados.filter((p) => p.id !== produtoId);
    },
    isProdutoSelecionado(produtoId) {
      return this.produtosSelecionados.some((p) => p.id === produtoId);
    },

    loadProdutosManuais() {
      if (!this.item.id) return;
      get(`/admin/marketing/vitrines/${this.item.id}/produtos`)
        .then((json) => { this.produtosSelecionados = json || []; })
        .catch(() => { this.produtosSelecionados = []; });
    },
    loadRegrasFixas() {
      get("/admin/marketing/vitrines/regras-fixas")
        .then((json) => { this.regrasFixas = json || []; })
        .catch(() => { this.regrasFixas = []; });
    },

    getImageUrl(produto) {
      const id = produto.imagemId || produto.id;
      return cdnUrlProduto(id);
    },
  },

  mounted() {
    this.loadRegrasFixas();
  },
};
</script>
